import ColumnToRowItem from './ColumnToRowItem'
import PropTypes from 'prop-types'

const ColumnToRowComponent = ({ data }) => {
  return (
    <div className="mx-auto mt-14 flex w-fit flex-col lg:mt-16 lg:flex-row">
      {data.map((item, index) => (
        <ColumnToRowItem
          key={index}
          item={item}
          classNames="border-b lg:border-b-0 lg:border-r last:border-0 lg:px-2 mt-10 first:mt-0 lg:mt-0 pb-10 last:pb-0 lg:pb-0"
        />
      ))}
    </div>
  )
}

ColumnToRowComponent.propTypes = {
  data: PropTypes.array,
}

ColumnToRowComponent.defaultProps = {
  data: [],
}

export default ColumnToRowComponent
